import isEmpty from 'lodash-es/isEmpty';

import { RANDOM_ID } from '@app/constants/general.constants';
import { BillingResponse, BillingPayload } from '@billing/entities/billing.payload';
import { BookingArrangementVM } from '@booking/entities/booking-arrangement';

export const BILLINGR_STATIC_ID_PREFIX = 'BILLING';

export function billingStaticId(): string {
  const sufix = Math.floor(Math.random() * RANDOM_ID);
  return `${BILLINGR_STATIC_ID_PREFIX}-${sufix}`;
}

export function isStaticBillingId(id: string): boolean {
  return id.startsWith(BILLINGR_STATIC_ID_PREFIX);
}

export function createAt(defaultBillingInfo: BillingResponse): boolean {
  return !isEmpty(defaultBillingInfo);
}

export function payloadToCreate(defaultBillingInfo: BillingResponse, arrangement: BookingArrangementVM): BillingPayload {
  const isNaturalPerson = defaultBillingInfo?.billing_info?.natural_person;
  const contactData = isNaturalPerson ? {
    email_address: arrangement.Email,
    phone_number: arrangement.Phone
  } : {
    phone_number: arrangement.Phone
  };
  return createAt(defaultBillingInfo) ? {
    user_id: defaultBillingInfo?.user_id,
    billing_info: {
      ...defaultBillingInfo?.billing_info,
      ...contactData
    }
  } : {} as BillingPayload;
}
